import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  ts_from: d.startOf('day').format(),
  ts_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'ts', title: t('grid.Дата и время'), change },
    { type: 'dict', dict: 'payment.payment_type', multiple: true },
    { type: 'dict', dict: 'payment.success' },
    { type: 'doublenumber', name: 'amount', title: t('grid.Сумма'), w: 80 },
    {
      type: 'meandouble',
      dict: 'payment.mean_type',
      multiple: true,
      name: 'mean_number',
      placeholder: '1234567890',
      label: t('grid.СО'),
      w: 140,
    },
    { type: 'input', name: 'vehicle_plate', title: t('sections.ГРЗ'), placeholder: t('form.А000AA 000 rus'), w: 150 },
    { type: 'app' },
    { type: 'input', name: 'check_number', title: t('grid.Счет N'), placeholder: '89546', w: 100 },
    { type: 'input', name: 'shift', title: t('grid.Смена'), placeholder: '89546', w: 70 },
    { type: 'parking' },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'paymentFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
